import { isNumber } from '@trimble-gcs/common';
import { classificationSchemeTranslations } from './classification-scheme.translations';

/**
 * This is somewhat subtle.
 *
 * The declared const is evaluated when the module is loaded,
 * and reflects translation strings in the 'en-US' source locale.
 *
 * The invocation in `getTranslatedClassificationName(id: number | string)`
 * occurs after the i18n infrastructure is up and running and returns translated strings.
 */
const classificationSchemeSources = classificationSchemeTranslations();

export function getSourceClassificationName(id: number | string): string | undefined {
  const key = getKey(id);
  return classificationSchemeSources[key]?.text;
}

export function getTranslatedClassificationName(id: number | string): string | undefined {
  const key = getKey(id);
  return classificationSchemeTranslations()[key]?.text;
}

function getKey(id: string | number) {
  return (isNumber(id) ? String(id) : id) as keyof typeof classificationSchemeSources;
}
